// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-list {
    padding: 24px;
}

.customer-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 16px;
}

.action-buttons {
    display: flex;
    gap: 8px;
}

.action-buttons button {
    min-width: 100px;
}

.delete-button:hover {
    color: #ff4d4f !important;
    border-color: #ff4d4f !important;
}

.restore-button:hover {
    color: #52c41a !important;
    border-color: #52c41a !important;
}

.deleted-row {
    background-color: #fafafa;
}

.deleted-row:hover td {
    background-color: #f0f0f0 !important;
}

.ant-table-row:hover .action-buttons button {
    opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/Customers/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,UAAU;AACd","sourcesContent":[".customer-list {\n    padding: 24px;\n}\n\n.customer-list-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n}\n\n.header-actions {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.action-buttons {\n    display: flex;\n    gap: 8px;\n}\n\n.action-buttons button {\n    min-width: 100px;\n}\n\n.delete-button:hover {\n    color: #ff4d4f !important;\n    border-color: #ff4d4f !important;\n}\n\n.restore-button:hover {\n    color: #52c41a !important;\n    border-color: #52c41a !important;\n}\n\n.deleted-row {\n    background-color: #fafafa;\n}\n\n.deleted-row:hover td {\n    background-color: #f0f0f0 !important;\n}\n\n.ant-table-row:hover .action-buttons button {\n    opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
